import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/by-tour-ids', 'get'>;
type ResponseBody = OASOutput<O, '/api/projects/by-tour-ids', 'get'>;

type Params = {
  tourIds: number[];
};

type Project = {
  id: number;
  name: string;
};

type Result = {
  projects: Project[];
};

export const getProjectsByTourIdsFactory = (apiClient: ApiClient) => {
  const getProjectsByTourIds = async (variables: Params) => {
    const requestParams = mapInputToRequestParams(variables);
    const response = await apiClient['/api/projects/by-tour-ids'].get(requestParams);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      query: {
        tourIds: input.tourIds,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      projects: response.projects.map((project) => ({
        id: project.id,
        name: project.name,
      })),
    };
  };

  return getProjectsByTourIds;
};
